import React, { lazy, Suspense } from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Wrap a lazy-loaded route component with a full-screen spinner fallback.
 * Used in App.js to keep the initial bundle small.
 */
export function lazyRoute(loader) {
  const C = lazy(loader);
  return (props) => (
    <Suspense fallback={
      <div className="min-h-[40vh] flex items-center justify-center">
        <Loader2 className="w-5 h-5 animate-spin text-[#0047AB]" />
      </div>
    }>
      <C {...props} />
    </Suspense>
  );
}
